import {Avatar, Grid, Card, CardContent, Typography, Theme, Tooltip, Link, type CardProps, type GridProps} from '@mui/material';
import {makeStyles} from '@mui/styles';
import type {Bookmark} from 'types';
import {useMobileScreen} from 'hooks';
import EditBookmarkIconButton from './EditBookmarkIconButton';
import DeleteBookmarkIconButton from './DeleteBookmarkIconButton';

export const FAVICON_SIZE = 128;
export const MIN_FAVICON_SIZE = 32;
export const MAX_FAVICON_SIZE = 64;
export const AVATAR_SIZE = 80;

const useStyles = makeStyles((theme : Theme) => ({
  card: {
    [theme.breakpoints.up('lg')]: {
      maxHeight: 117,
    }
  },
  cardContent: {
    [theme.breakpoints.up('lg')]: {
      maxHeight: 117,
    }
  },
  avatar: {
    boxShadow: theme.shadows[1],
    width: AVATAR_SIZE,
    height: AVATAR_SIZE,
    '& img': {
      width: 'initial',
      height: 'initial',
      minWidth: MIN_FAVICON_SIZE,
      minHeight: MIN_FAVICON_SIZE,
      maxWidth: MAX_FAVICON_SIZE,
      maxHeight: MAX_FAVICON_SIZE,
    }
  },
  name: {
    fontWeight: '500',
  }
}), {name: 'AdminBookmarkCard'});

type AdminBookmarkCardProps = CardProps & {
  bookmark: Bookmark;
};

const AdminBookmarkCard = ({bookmark} : AdminBookmarkCardProps) => {
  const {key, name, uri} = bookmark;
  const classes = useStyles();
  const isMobileScreenWidth = useMobileScreen();
  const actionsGridProps : Partial<GridProps> = isMobileScreenWidth
  ? {
      spacing: 2,
      justifyContent: 'flex-end',
    }
  : {
      justifyContent: 'flex-end',
      spacing: 1,
    }
  return (
    <Card className={classes.card}>
      <CardContent className={classes.cardContent}>
        <Grid container wrap='nowrap' spacing={2} alignItems='center'>
          <Grid item>
            <Avatar className={classes.avatar} src={`https://www.google.com/s2/favicons?sz=${FAVICON_SIZE}&domain_url=${uri}`} />
          </Grid>
          <Grid item xxs zeroMinWidth>
            <Grid container spacing={1}>
              <Grid item zeroMinWidth xxs={12}>
                <Tooltip title={name} placement='right'>
                  <Typography className={classes.name} variant='h5' noWrap>{name}</Typography>
                </Tooltip>
              </Grid>
              <Grid item zeroMinWidth xxs={12}>
                <Tooltip title={uri} placement='right'>
                  <Typography noWrap>
                    <Link href={uri} target='_blank' rel='noreferrer' underline='hover' color='textPrimary' variant='body2'>{uri}</Link>
                  </Typography>
                </Tooltip>
              </Grid>
              <Grid item zeroMinWidth xxs={12}>
                <Grid container {...actionsGridProps}>
                  <Grid item>
                    <EditBookmarkIconButton bookmark={bookmark} />
                  </Grid>
                  <Grid item>
                    <DeleteBookmarkIconButton bookmarkName={name} bookmarkKey={key} />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default AdminBookmarkCard;